import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45070f84"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-recommend-inner -is-form" }
const _hoisted_2 = { class: "p-recommend-form__send-field --2-buttons" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "前に戻る", -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "保存して完了", -1))
const _hoisted_7 = [
  _hoisted_6
]

import { inject, ref, watch } from 'vue';
import QualEnglish from './components/QualEnglish.vue';
import QualLicense from './components/QualLicense.vue';
import QualOtherLanguage from './components/QualOtherLanguage.vue';
import { CareerResumeInfoDetail, QualificationLanguageDetail } from '@/types';
import { ValidationResult } from 'vee-validate';


export default /*#__PURE__*/_defineComponent({
  __name: 'QualificationsForm',
  props: {
    submitFn: null,
    activeTab: null,
    careerData: null,
    setFieldValue: null,
    validateField: null
  },
  setup(__props: any) {

const props = __props as {
  submitFn: () => Promise<any>;
  activeTab: string;
  careerData?: CareerResumeInfoDetail;
  setFieldValue: <T extends string>(field: T, value: any, opts?: any) => void;
  validateField: (field: string) => Promise<ValidationResult>;
}

const TAB_NAME = 'qualifications';



const switchTabAndValidateFn = inject<(tabId: string) => void>('switchTabAndValidate');

const qualDetailCount = ref(0);
const isDisabledSubmit = ref(false);
const qualDetails = ref<any[]>([]);
const qualLangDetail = ref<QualificationLanguageDetail>();

watch(() => props.careerData, (newVal) => {
  if (newVal) {
    setFormData(newVal);
  }
});

async function handleSubmit() {
  
  if(!isDisabledSubmit.value)
  {    
    isDisabledSubmit.value = true;
    await props.submitFn();
    isDisabledSubmit.value = false;
  }
}

const toEmpty = (v: any) => v ? v : '';

function setFormData(formData: CareerResumeInfoDetail){
  const qualObject: Record<string, any> = {
    'qualOther': formData.qualOther,
    'qualLangDetail.toeic': formData.qualLangDetail?.toeic,
    'qualLangDetail.toeicY': toEmpty(formData.qualLangDetail?.toeicY),
    'qualLangDetail.toeicM': toEmpty(formData.qualLangDetail?.toeicM),
    'qualLangDetail.toefl': formData.qualLangDetail?.toefl,
    'qualLangDetail.toeflY': toEmpty(formData.qualLangDetail?.toeflY),
    'qualLangDetail.toeflM': toEmpty(formData.qualLangDetail?.toeflM),
    'qualLangDetail.englishLevelId': toEmpty(formData.qualLangDetail?.qualEnglishLevelId),
    'qualLangDetail.engMemo': formData.qualLangDetail?.engMemo,

    'qualLangDetail.otrLang1Id': toEmpty(formData.qualLangDetail?.otrLang1Id),
    'qualLangDetail.otrLang1LevelId': toEmpty(formData.qualLangDetail?.otrLang1LevelId),
    'qualLangDetail.otrLang2Id': toEmpty(formData.qualLangDetail?.otrLang2Id),
    'qualLangDetail.otrLang2LevelId': toEmpty(formData.qualLangDetail?.otrLang2LevelId),
    'qualLangDetail.otrLang3Id': toEmpty(formData.qualLangDetail?.otrLang3Id),
    'qualLangDetail.otrLang3LevelId': toEmpty(formData.qualLangDetail?.otrLang3LevelId),
  };

  // fill missing items
  const qDetails = [];
  if (props.careerData?.qualDetails && props.careerData?.qualDetails.length) {
    for (let i = 0; i < props.careerData?.qualDetails.length; i++) {
        qDetails.push(props.careerData.qualDetails[i]);
    }
  }
  qDetails.forEach((q, i) => {
    qualObject[`qualDetails[${i}].qlId`] = toEmpty(q.qlId);
    qualObject[`qualDetails[${i}].licenseId`] = toEmpty(q.licenseId);
    qualObject[`qualDetails[${i}].qualYr`] = toEmpty(q.qualYr);
    qualObject[`qualDetails[${i}].qualMon`] = toEmpty(q.qualMon);
  });

  qualDetailCount.value = qDetails.length;
  qualLangDetail.value = {...props.careerData?.qualLangDetail} as QualificationLanguageDetail;
  qualDetails.value = [...qDetails];

  for (const key in qualObject) {
    props.setFieldValue(key, qualObject[key]);
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: TAB_NAME,
    class: _normalizeClass(["tab-content", { 'show': __props.activeTab === 'qualifications' }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(QualLicense, {
        "validate-field": __props.validateField,
        "set-field-value": __props.setFieldValue,
        "qual-detail-count": qualDetailCount.value
      }, null, 8, ["validate-field", "set-field-value", "qual-detail-count"]),
      _createVNode(QualEnglish),
      _createVNode(QualOtherLanguage, { "qual-lang-detail": qualLangDetail.value }, null, 8, ["qual-lang-detail"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("a", {
          class: _normalizeClass(["p-recommend-form__send -is-prev", { 'active': __props.activeTab === 'education' }]),
          href: "#education",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(switchTabAndValidateFn)!('#education')), ["prevent"]))
        }, _hoisted_4, 2),
        _createElementVNode("a", {
          class: _normalizeClass(["p-recommend-form__send", { 'disabled-link': isDisabledSubmit.value }]),
          href: "#",
          onClick: _withModifiers(handleSubmit, ["prevent"])
        }, _hoisted_7, 10, _hoisted_5)
      ])
    ])
  ], 2))
}
}

})